export const FOSTableYesNoCell = (props: any) => {
  const { value } = props;

  if (value === '' || value === null) return <div></div>;

  return <div>{Number(value) ? 'Y' : 'N'}</div>;
};
